// src/pages/Main/apps.js

import React, { Component } from "react";
import { Container } from "react-bootstrap";
import { ExampleCard, MutedPill, StatusPill } from "pages/Main/frontCards";
import { APPS, EXAMPLES } from "pages/Main/frontContent";
import { PageHead, SectionTitle } from "pages/Main/frontPage";
import Carousel from "pages/Main/frontCarousel";
import FrontShot, { shownShots } from "pages/Main/frontShot";
import Title from "context/title";

// Counted after leaving out a picture not yet in FRONT_SHOTS, so a lone real picture never gets carousel controls.
const Media = ({ app }) => {
  const shots = shownShots(app.shots);
  if (shots.length > 1) {
    return <Carousel shots={shots} label={app.title} />;
  }
  return shots.length ? <div className="fp-card-img"><FrontShot name={shots[0].name} alt={shots[0].alt} /></div> : null;
};

const Feature = ({ app, flip }) => (
  <article className={`fp-feature${flip ? " fp-flip" : ""}`}>
    <div className="fp-feature-media">
      <Media app={app} />
    </div>
    <div className="fp-feature-text">
      <div className="fp-card-pills">
        <StatusPill status={app.status} />
        <MutedPill>{app.domain}</MutedPill>
      </div>
      <h2>{app.title}</h2>
      <p>{app.long}</p>
      <dl className="fp-props">
        <div><dt>Govern</dt><dd>{app.govern}</dd></div>
        <div><dt>Audit</dt><dd>{app.audit}</dd></div>
        <div><dt>Widget</dt><dd><code className="fp-card-code">{app.widget}</code></dd></div>
      </dl>
    </div>
  </article>
);

export default class Apps extends Component {
  componentDidMount() {
    Title.set("Apps");
  }

  render() {
    return (
      <>
        <PageHead
          eyebrow="Apps"
          title="Apps built from BlobHub primitives"
          text={"An app is a configuration of sessions, threads, workflows, schedules and policies, deployed as "
            + "content with no platform code of its own. Because every app is made of the same parts, each one is "
            + "governed and audited the same way, and they can hand work to one another."} />
        <Container className="fp-page-stack">
          <Feature app={APPS.missions} />
          <Feature app={APPS.daytrader} flip />
          <section>
            <SectionTitle
              eyebrow="What else teams build"
              title="The same primitives, every domain"
              text={"Examples of apps that stand on what BlobHub ships today. Each pairs the rule that matters with "
                + "the question someone will ask afterwards."} />
            <div className="fp-grid fp-g3">
              {EXAMPLES.map((example) => <ExampleCard key={example.title} example={example} />)}
            </div>
          </section>
        </Container>
      </>
    );
  }
}
